module.exports = __webpack_public_path__ + "static/cc-2-a9871df018846c5a10fc89d4dbd89cc5.jpg";